import { render, staticRenderFns } from "./CauseRisk.vue?vue&type=template&id=26c9d90f&scoped=true"
import script from "./CauseRisk.vue?vue&type=script&lang=js"
export * from "./CauseRisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c9d90f",
  null
  
)

export default component.exports